import { render, staticRenderFns } from "./SealApprove.vue?vue&type=template&id=2ff7e3a1&scoped=true&"
import script from "./SealApprove.vue?vue&type=script&lang=js&"
export * from "./SealApprove.vue?vue&type=script&lang=js&"
import style0 from "./SealApprove.vue?vue&type=style&index=0&id=2ff7e3a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7e3a1",
  null
  
)

export default component.exports